import { Pipe, PipeTransform } from '@angular/core';
import { CounterDto, MeterType } from '@lib-ui/client';
import { KnownObisCodes, MeterProperties } from '@lib-ui/lib/models';

@Pipe({
  name: 'obisUnit',
})
export class ObisUnitPipe implements PipeTransform {

  transform(counter: CounterDto, meterType: MeterType): unknown {
    const unit = counter.obis?.unit ?? '';
    if (unit === KnownObisCodes.NotApplicable) {
      return MeterProperties.get(meterType)?.unitString;
    }
    return unit;
  }

}
